// extracted by mini-css-extract-plugin
export default {"wrapper":"TablePagination_wrapper__x30DP","info":"TablePagination_info__kOA1A"};